import styled from "styled-components";

export const Button = styled.button`
  appearance: none;
  color: white;
  background: none;
  border: none;
`